import { Component, OnInit, signal, computed, inject } from '@angular/core';
import { FormBuilder, FormGroup, Validators, ReactiveFormsModule } from '@angular/forms';
import { NgIf, NgClass } from '@angular/common';
import { Title } from '@angular/platform-browser';
import { Router } from '@angular/router';

// Models
import { LoginCredentials, LoginState } from '../../../../core/models/auth.model';

// Services
// import { UserService } from '../../../user/user.service';
// import { SessionService } from '../../../services/session.service';

// Componets
import { ForgotPasswordComponent } from '../forgot-password/forgot-password.component';
import { AuthenticationService } from '../../services/auth.service';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss'],
  standalone: true,
  imports: [NgIf, NgClass, ReactiveFormsModule, ForgotPasswordComponent]
})
export class LoginComponent implements OnInit {
  private readonly fb = inject(FormBuilder);
  private readonly titleService = inject(Title);
  private readonly router = inject(Router);
  private readonly authenticationService = inject(AuthenticationService);
  // private readonly userService = inject(UserService);
  // private readonly sessionService = inject(SessionService);

  // Signals
  loginState = signal<LoginState>('idle');
  showForgotPassword = signal(false);
  errorMessage = signal<string>('');
  formSubmitted = signal(false);

  // Reactive Form
  loginForm: FormGroup;

  // Getters 
  get email() { return this.loginForm.get('email'); }
  get password() { return this.loginForm.get('password'); }

  // Getters reactivos para el estado de la UI (sin warnings ✅)
  get isLoading(): boolean { return this.loginState() === 'loading'; }
  get hasError(): boolean { return this.loginState() === 'error'; }
  get isSuccess(): boolean { return this.loginState() === 'success'; }

  constructor() {
    this.loginForm = this.fb.nonNullable.group({
      email: ['', [
        Validators.required,
        Validators.email,
        Validators.pattern(/^[\w0-9_\-.]+@[\w0-9_\-.]+\.[\w]{2,}$/)
      ]],
      password: ['', [
        Validators.required,
        Validators.minLength(0)
      ]]
    });
  }

  ngOnInit(): void {
    this.titleService.setTitle('HUBX RMA');
  }

  async login(): Promise<void> {
    if (this.loginForm.invalid) {
      this.loginForm.markAllAsTouched();
      return;
    }

    if (this.isLoading) {
      return;
    }

    try {
      this.loginState.set('loading');
      this.errorMessage.set('');
      const credentials: LoginCredentials = this.loginForm.getRawValue();
      await this.authenticationService.login(credentials);
      this.loginState.set('success');

    } catch (error) {
      this.loginState.set('error');
      this.errorMessage.set(this.getErrorMessage(error));
      console.error('Login error:', error);
    }
  }

  toggleForgotPassword(): void {
    this.showForgotPassword.update(value => !value);
    this.loginState.set('idle');
    this.errorMessage.set('');
    this.formSubmitted.set(false);
  }

  private getErrorMessage(error: unknown): string {
    if (error instanceof Error) {
      return error.message;
    }
    return 'Login failed!';
  }



}